<template>
    <div class="ah-page analysis-vendors-page">
        <div class="page-header bottom-margin">
            <div class="ah-container">
                <div class="title-row">
                    <div class="title">
                        <h1>客戶貢獻分析</h1>
                    </div>
                    <div class="actions">
                        <el-select v-model="year" placeholder="年度" @change="handleYearChange" size="small">
                            <el-option v-for="item in yearList" :key="item" :label="item" :value="item" />
                        </el-select>
                    </div>
                </div>
            </div>
        </div>
        <div class="ah-container">
            <div class="ah-panel">
                <div class="al-panel-tabs center">
                    <div :class="{ item: true, active: type === 'invoice' }" @click="switchType('invoice')" @keydown="() => {}">
                        <span class="ico"></span>
                        <span class="name">發票</span>
                    </div>
                    <div :class="{ item: true, active: type === 'project' }" @click="switchType('project')" @keydown="() => {}">
                        <span class="ico"></span>
                        <span class="name">專案</span>
                    </div>
                </div>
            </div>
            <div class="ah-panel">
                <div class="panel-header gray small">
                    <div class="panel-title">
                        <div v-if="type === 'invoice'">{{ year }} 年前十大客戶</div>
                        <div v-if="type === 'project'">{{ year }} 年前十大客戶專案總額</div>
                    </div>
                    <div class="panel-action"></div>
                </div>
                <div class="panel-body">
                    <v-chart :option="option" style="width: 100%; height: 300px" />
                </div>
            </div>
            <div class="ah-panel">
                <div class="panel-header gray small">
                    <div class="panel-title">
                        <div v-if="type === 'invoice'">{{ year }} 年所有客戶</div>
                        <div v-if="type === 'project'">{{ year }} 年所有專案客戶</div>
                    </div>
                    <el-button type="normal" size="small" class="export-btn" @click="onExport">
                        匯出Excel
                    </el-button>
                </div>
                <div class="panel-body">
                    <div class="tool-block">
                        <el-input v-model="vendorName" placeholder="輸入公司名稱搜尋" size="" style="width: 100%; max-width: 300px"> </el-input>
                        <el-radio-group v-if="type == 'invoice'" class="overiew-radio-group" v-model="mode" size="small">
                            <el-radio-button label="summary" border> 發票總額 </el-radio-button>
                            <el-radio-button label="arrived"> 收款狀況 </el-radio-button>
                        </el-radio-group>
                    </div>
                    <invoice-tab v-if="type == 'invoice'" :mode="mode" :data="filteredVendorPaymentList" :v-loading="isLoading" />
                    <project-tab v-if="type == 'project'" :data="filteredVendorPaymentList" :v-loading="isLoading" @project-click="handleProjectClick" />
                </div>
            </div>
        </div>
        <ProjectDetailDialog ref="projectDetailDialog" :visible="projectDetailDialog.visible" @close="handleDetailDialogClose" :sno="projectDetailDialog.sno" />
    </div>
</template>
<script>
import ProjectDetailDialog from '@/components/dashboard/Project/ProjectDetailDialog.vue';
import { use } from 'echarts/core';
import { CanvasRenderer } from 'echarts/renderers';
import { PieChart } from 'echarts/charts';
import {
    TitleComponent, TooltipComponent, LegendComponent, GridComponent,
} from 'echarts/components';
import VChart from 'vue-echarts';

import _ from 'lodash';
import moment from 'moment';
import { MyXLSX2 } from '@/utils/xlsxExport2';
import invoiceTab from './Vender/invoiceTab.vue';
import projectTab from './Vender/projectTab.vue';

use([CanvasRenderer, PieChart, TitleComponent, TooltipComponent, LegendComponent, GridComponent]);

export default {
    name: 'AnalysisVendor',
    components: {
        VChart,
        ProjectDetailDialog,
        invoiceTab,
        projectTab,
    },
    data() {
        return {
            year: null,
            vendorName: '',
            type: 'invoice', // invoice | project
            pageData: {
                newVendorAmount: null,
                newVendorCount: null,
                oldVendorAmount: null,
                oldVendorCount: null,
                vendorPaymentList: [],
            },
            projectDetailDialog: {
                visible: false,
                sno: null,
            },
            isLoading: false,
            option: {
                tooltip: {
                    trigger: 'item',
                    formatter: '{a} <br/>{b} : {c} ({d}%)',
                },
                legend: {
                    orient: 'vertical',
                    left: 'left',
                    data: [],
                    show: false,
                },
                series: [
                    {
                        name: '營收貢獻',
                        type: 'pie',
                        radius: ['00%', '80%'],
                        center: ['50%', '50%'],
                        data: [],
                        emphasis: {
                            itemStyle: {
                                shadowBlur: 10,
                                shadowOffsetX: 0,
                                shadowColor: 'rgba(0, 0, 0, 0.5)',
                            },
                        },
                    },
                ],
            },
            yearList: [],
            mode: 'summary',
        };
    },
    computed: {
        getTop10TotalAmount() {
            if (this.pageData.top10VendorPayments) {
                return this.pageData.top10VendorPayments.reduce((accumulator, currentValue) => accumulator + currentValue.amt, 0);
            }

            return 0;
        },
        filteredVendorPaymentList() {
            if (this.vendorName) {
                return this.pageData.vendorPaymentList.filter((x) => x.fnam.indexOf(this.vendorName) !== -1);
            }

            return this.pageData.vendorPaymentList;
        },
    },
    mounted() {
        const urlYear = parseInt(this.$route.query.year, 10);
        if (urlYear) {
            this.year = urlYear;
        }

        const urlType = this.$route.query.type;
        if (urlType && (urlType === 'invoice' || urlType === 'project')) {
            this.type = urlType;
        }

        this.fetchYears().then(() => {
            if (this.year == null) this.year = new Date().getFullYear();

            this.fetchData().then(() => {
                this.updateCharts();
            });
        });
    },
    methods: {
        handleYearChange() {
            this.$router.replace({
                name: 'analysis-vendor',
                query: {
                    year: this.year,
                    type: this.type,
                },
            });

            this.fetchData().then(() => {
                this.updateCharts();
            });
        },
        fetchYears() {
            return this.$api({
                url: 'FinancialAnalysisPage/GetVendorPaymentYearOptions',
                method: 'GET',
            }).then((resp) => {
                this.status = 'success';

                if (resp.data.options && resp.data.options.length > 0) {
                    this.yearList = resp.data.options.reverse();
                } else {
                    this.yearList = [new Date().getFullYear()];
                }
            });
        },
        showAmount(percentage, amt) {
            return amt;
        },
        switchType(type) {
            this.type = type;

            this.$router.replace({
                name: 'analysis-vendor',
                query: {
                    year: this.year,
                    type: this.type,
                },
            });

            this.fetchData().then(() => {
                this.updateCharts();
            });
        },
        fetchData() {
            if (this.type === 'invoice') {
                return this.fetchInvoiceData();
            }
            return this.fetchProjectData();
        },
        fetchInvoiceData() {
            this.isLoading = true;

            return this.$api({
                url: 'FinancialAnalysisPage/GetVendorInvoicePaymentAnalysis',
                params: {
                    Year: this.year,
                },
                method: 'GET',
            })
                .then((result) => {
                    console.log(this.pageData);

                    this.pageData.newVendorAmount = result.data.newVendorAmount;
                    this.pageData.newVendorCount = result.data.newVendorCount;
                    this.pageData.oldVendorAmount = result.data.oldVendorAmount;
                    this.pageData.oldVendorCount = result.data.oldVendorCount;
                    this.pageData.vendorPaymentList = result.data.vendorPaymentList;

                    // 自動計算總金額
                    this.pageData.vendorPaymentList.forEach((item) => {
                        const nonTaxAmount = item.invoiceAmount - item.taxAmount;
                        const receivedPER = Math.round((item.receivedAMT / item.invoiceAmount) * 1000) / 10;
                        const unreceivedPER = Math.round((100 - receivedPER) * 10) / 10;

                        _.set(item, 'amt', item.invoiceAmount);
                        _.set(item, 'nonTaxAmount', nonTaxAmount);
                        _.set(item, 'receivedPER', receivedPER);
                        _.set(item, 'unreceivedPER', unreceivedPER);
                    });

                    // 計算總銷售額 %
                    const total = _.sumBy(this.pageData.vendorPaymentList, 'invoiceAmount');
                    this.pageData.vendorPaymentList.forEach((item) => {
                        const summaryPER = Math.round((item.invoiceAmount / total) * 1000) / 10;
                        _.set(item, 'summaryPER', summaryPER);
                    });

                    // 用總金額排列
                    this.pageData.vendorPaymentList.sort((a, b) => {
                        if (a.nonTaxAmount > b.nonTaxAmount) return -1;
                        if (a.nonTaxAmount < b.nonTaxAmount) return 1;
                        return 0;
                    });
                    // 加上名次
                    this.pageData.vendorPaymentList.forEach((item, i) => {
                        _.set(item, 'index', i + 1);
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        fetchProjectData() {
            this.isLoading = true;

            return this.$api({
                url: 'FinancialAnalysisPage/GetVendorProjectPaymentAnalysis',
                params: {
                    Year: this.year,
                },
                method: 'GET',
            })
                .then((result) => {
                    console.log(this.pageData);

                    this.pageData.newVendorAmount = result.data.newVendorAmount;
                    this.pageData.newVendorCount = result.data.newVendorCount;
                    this.pageData.oldVendorAmount = result.data.oldVendorAmount;
                    this.pageData.oldVendorCount = result.data.oldVendorCount;
                    this.pageData.vendorPaymentList = result.data.vendorPaymentList;

                    // 計算 %
                    const total = this.pageData.vendorPaymentList.reduce((acc, obj) => acc + obj.amt, 0);
                    for (let i = 0; i < this.pageData.vendorPaymentList.length; i += 1) {
                        const { amt } = this.pageData.vendorPaymentList[i];
                        const percent = Math.round((amt / total) * 1000) / 10;
                        this.pageData.vendorPaymentList[i].percent = percent;
                    }

                    // 用總金額排列
                    this.pageData.vendorPaymentList.sort((a, b) => {
                        if (a.amt > b.amt) return -1;
                        if (a.amt < b.amt) return 1;
                        return 0;
                    });
                    this.pageData.vendorPaymentList.forEach((item, i) => {
                        _.set(item, 'index', i + 1);
                        _.set(item, 'pjLength', item.projects.length);
                        _.set(item, 'installmentInvoicedCount', _.sumBy(item.projects, 'installmentInvoicedCount'));
                    });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
        getCnyRat(cny) {
            const cnyOption = this.$store.getters['cny/cnyOptions'].find((x) => x.cny === cny);
            if (cnyOption) return cnyOption.rat;
            return 1;
        },

        // 更新圖表
        updateCharts() {
            // 前十名
            const seriesData = [];
            const others = {
                name: '其他',
                value: 0,
            };

            this.pageData.vendorPaymentList.forEach((item, index) => {
                if (index < 10) {
                    // 十名內
                    seriesData.push({
                        name: item.fnam,
                        value: Math.round(item.amt),
                    });
                } else {
                    // 其他
                    others.value += item.amt;
                }
            });

            // 如果有其他，加進 series
            if (others.value > 0) {
                seriesData.push(others);
            }
            this.option.series[0].data = seriesData;
        },
        handleProjectClick(pjSno) {
            this.projectDetailDialog.visible = true;
            this.projectDetailDialog.sno = pjSno;
        },
        handleDetailDialogClose() {
            this.projectDetailDialog.visible = false;
            this.projectDetailDialog.sno = null;
        },

        onExport() {
            const wb = MyXLSX2.createBook();
            if (this.type === 'invoice') {
                MyXLSX2.bookAppendSheet(wb, this.onExportInvoice(), '發票');
            } else {
                MyXLSX2.bookAppendSheet(wb, this.onExportProject(), '排名');
                MyXLSX2.bookAppendSheet(wb, this.onExportProjectDetail(), '明細');
            }

            MyXLSX2.download(wb, `${this.year}客戶貢獻分析`);
        },
        onExportInvoice() {
            const title = `${this.year}客戶貢獻分析 - 發票`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '客戶名稱', width: 30, align: 'left' },
                { text: '應收發票總額', align: 'right', number: true },
                { text: '營業稅', align: 'right', number: true },
                { text: '銷售額(未稅)', align: 'right', number: true },
                { text: '佔總銷售額', align: 'right' },
                { text: '開立發票張數', align: 'right', number: true },
                { text: '已收款', align: 'right', number: true },
                { text: '已收款%', align: 'right' },
                { text: '未收款', align: 'right', number: true },
                { text: '未收款%', align: 'right' },
            ];
            // 內容資料
            const bodyRows = [];
            this.filteredVendorPaymentList.forEach((item, i) => {
                const row = [
                    i + 1,
                    item.fnam,
                    item.amt,
                    item.taxAmount,
                    item.nonTaxAmount,
                    `${item.summaryPER} %`,
                    item.inV_CNT,
                    item.receivedAMT,
                    `${item.receivedPER} %`,
                    item.unreceivedAMT,
                    `${item.unreceivedPER} %`,
                ];
                bodyRows.push(row);
            });

            // 總計列
            const totalAmt = _.sumBy(this.filteredVendorPaymentList, 'amt');
            const totalTaxAmount = _.sumBy(this.filteredVendorPaymentList, 'taxAmount');
            const totalNonTaxAmount = _.sumBy(this.filteredVendorPaymentList, 'nonTaxAmount');
            const totalInvCnt = _.sumBy(this.filteredVendorPaymentList, 'inV_CNT');
            const totalReceivedAmt = _.sumBy(this.filteredVendorPaymentList, 'receivedAMT');
            const totalUnreceivedAmt = _.sumBy(this.filteredVendorPaymentList, 'unreceivedAMT');
            bodyRows.push(['', '總計', totalAmt, totalTaxAmount, totalNonTaxAmount, '', totalInvCnt, totalReceivedAmt, '', totalUnreceivedAmt, '']);

            // 表頭資訊
            const cd = moment().format('YYYY-MM-DD');
            const headRows = [
                { label: '查詢區間', value: `${this.year}年度` },
                { label: '製表日期', value: cd },
            ];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        onExportProject() {
            const title = `${this.year}客戶貢獻分析 - 專案排名`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '客戶名稱', width: 30, align: 'left' },
                { text: '佔年度專案總額', align: 'right' },
                { text: '專案數', align: 'right', number: true },
                { text: '已開發票數', align: 'right', number: true },
                { text: '當年度發票開立總額', align: 'right', number: true },
                { text: '幣別', align: 'right', number: true },
            ];
            // 內容資料
            const bodyRows = [];
            this.filteredVendorPaymentList.forEach((item, i) => {
                const row = [i + 1, item.fnam, `${item.percent}%`, item.pjLength, item.installmentInvoicedCount, item.amt, 'TWD'];
                bodyRows.push(row);
            });

            // 總計列
            const totalPjtCnt = _.sumBy(this.filteredVendorPaymentList, 'pjLength');
            const totalIssuedInvoiceCnt = _.sumBy(this.filteredVendorPaymentList, 'installmentInvoicedCount');
            const totalAmt = _.sumBy(this.filteredVendorPaymentList, 'amt');
            bodyRows.push(['', '總計', '', totalPjtCnt, totalIssuedInvoiceCnt, totalAmt, '']);

            // 表頭資訊
            const cd = moment().format('YYYY-MM-DD');
            const headRows = [
                { label: '查詢區間', value: `${this.year}年度` },
                { label: '製表日期', value: cd },
            ];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        onExportProjectDetail() {
            const details = _.flatMap(this.filteredVendorPaymentList, 'projects');
            const title = `${this.year}客戶貢獻分析 - 專案明細`;

            // 內容表頭
            const bodyHeader = [
                { text: '', width: 5, align: 'center' },
                { text: '客戶名稱', width: 30, align: 'left' },
                { text: '單號', align: 'left' },
                { text: '專案類型', align: 'center' },
                { text: '專案名稱', align: 'left' },
                { text: '分期／已開發票', align: 'center' },
                { text: '專案經理', align: 'center' },
                { text: '專案經辦人', align: 'center' },
                {
                    text: '專案總價（台幣）',
                    width: 18,
                    align: 'right',
                    number: true,
                },
                {
                    text: '當年度發票開立小計（原幣別）',
                    width: 30,
                    align: 'right',
                    number: true,
                },
                { text: '幣別', align: 'center' },
                { text: '即時匯率', align: 'right' },
                {
                    text: '當年度發票開立小計（台幣）',
                    width: 30,
                    align: 'right',
                    number: true,
                },
            ];
            // 內容資料
            const bodyRows = [];
            details.forEach((item, i) => {
                const row = [
                    i + 1,
                    item.vdR_NAM,
                    item.poo,
                    item.pjcaT_NAM,
                    item.nam,
                    `${item.installmentCount}／${item.installmentInvoicedCount}`,
                    item.stF_NAM,
                    item.projectAuditorName ? item.projectAuditorName : '無',
                    item.amt * this.getCnyRat(item.cny),
                    item.thisYearAmt,
                    item.cny,
                    this.getCnyRat(item.cny),
                    item.thisYearAmt * this.getCnyRat(item.cny),
                ];
                bodyRows.push(row);
            });

            // 總計列
            const totalAmt = _.sumBy(details, (o) => o.amt * this.getCnyRat(o.cny));
            const totalThisYearAmt = _.sumBy(details, (o) => o.thisYearAmt * this.getCnyRat(o.cny));
            bodyRows.push(['', '總計(約當台幣)', '', '', '', '', '', '', totalAmt, '', '', '', totalThisYearAmt]);

            // 表頭資訊
            const cd = moment().format('YYYY-MM-DD');
            const headRows = [
                { label: '查詢區間', value: `${this.year}年度` },
                { label: '製表日期', value: cd },
            ];

            return MyXLSX2.createSheet(title, headRows, bodyHeader, bodyRows);
        },
        percentageText(percentage) {
            const TEXT = `${percentage}`;
            if (TEXT.includes('NaN') || TEXT.includes('Infinity')) {
                return '--';
            }
            return TEXT;
        },
    },
};
</script>
<style lang="scss">
.analysis-vendors-page {
    .panel-header {
        display: flex;
        justify-content: space-between;
        align-items: center;
    }
    .export-btn {
        margin-right: 20px;
    }
    .inner-project-list-table {
        tr:hover > td {
            background-color: #f8f8f8 !important;
        }

        tr {
            background-color: #f8f8f8;
        }
    }
    .tool-block {
        display: flex;
        justify-content: space-between;
        align-items: center;
        width: 100%;
        margin-bottom: 15px;
    }
}
</style>
